import { useEffect, useState } from "react"
import { IGraduateAttach } from "../../interfaces/IGraduateAttach"
import { convertToBase64 } from "../../helpers/sharedFunctions";
import { AttachingFile } from "../../interfaces/IGraduateFilterObjMsg";
import { loadSignature, uploadSignature } from "../../services/signatureService";
import { Grid, Typography } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import { Link as LinkTo } from 'react-router-dom';
import Link from '@material-ui/core/Link';

const Signature: React.FC<{ updateSignatureParent: (signature: IGraduateAttach) => void }> = ({ updateSignatureParent })=> {

    const [signatureAttach, setSignatureAttach] = useState<IGraduateAttach>(new IGraduateAttach())
    const [errorSignature, setErrorSignature] = useState<string>('');

    useEffect(() => {
        reload();
    }, []);

    const reload = ()=>{
        loadSignature().then((data: AttachingFile | null) => {
            if (data) {
                updateSignatureParent({
                    attachingFiles: [data]
                });
                console.log("data", data);
                setSignatureAttach({
                    attachingFiles: [data]
                });
            }
        })
    }

    const handleUploadSignature = async (e: any) => {
        setErrorSignature('');
        const { name } = e.target;

        if (name === "signature" && e.target.files.length > 0) {
            const file: File = e.target.files[0];
            const allowedTypes = ["image/png"];

            if (!allowedTypes.includes(file.type)) {
                setErrorSignature('Solo puede subir archivos en formatos permitidos.');
                return;
            }

            const img = new Image();
            const objectUrl = URL.createObjectURL(file);

            img.onload = async () => {
                const { width, height } = img;

                // Max size validation
                if (width <= 400 && height <= 300) {
                    const base64File: any = await convertToBase64(file);

                    if (base64File.length > 0) {
                        await uploadSignature(file);
                        reload();
                    }
                } else {
                    setErrorSignature('La imagen debe tener un tamaño máximo de 400x300 píxeles.');
                    URL.revokeObjectURL(objectUrl); 
                }
            };  

            img.onerror = () => {
                setErrorSignature('No se pudo cargar la imagen.');
                URL.revokeObjectURL(objectUrl); 
            };

            img.src = objectUrl;
        }
    };

    return (
        <Grid item xs={12} className="documents-mass-message">
            <Typography variant="h5" className="description-documents-text regular-serif">En esta sección debe agregar su firma en formato png con un tamaño máximo de 400x300 pixeles. Si no adjunta una firma no podrá enviar el correo electrónico, si ya tiene una firma en el sistema no podra eliminarla pero puede reemplazarla por una nueva</Typography>
            {
                signatureAttach.attachingFiles.length > 0 &&
                <Grid container item xs={12} justify="flex-start" direction="column">
                    {signatureAttach.attachingFiles.map((file, index) => (
                        <div key={index} className="list-file-element">
                            <Link target="_blank" rel="noopener" href={file.previewUrl}>
                                <img src={file.previewUrl} alt={file.filename} />
                                <Typography align="center" variant="h6" className="regular-serif">
                                    {file.filename}
                                </Typography>
                            </Link>
                        </div>
                    ))}
                </Grid>
            }
            <Typography variant="h6" className="Regular-serif primaryError">
                {errorSignature}
            </Typography>
            <Grid container item xs={12} justify="flex-start">
                <div className="upload-button-container">
                    <Button variant="contained" component="label" className="upload-button">
                        <Typography variant="h5" className="regular-serif">
                            {signatureAttach.attachingFiles.length > 0 ? "Cambiar Firma" : "Agregar Firma"}
                        </Typography>
                        <div>
                            <input type="file" name="signature" onChange={handleUploadSignature} accept=".jpg,.jpeg,.png" hidden />
                        </div>
                    </Button>
                </div>
            </Grid>
        </Grid>)

}

export default Signature;